export const SIM_FILE = "SIM_FILE";
export const SIM_GENERATE = "SIM_GENERATE";
export const SIM_MODES = [SIM_FILE, SIM_GENERATE];
export const SCN_POOL = "SCN_POOL";
export const SCN_RACK = "SCN_RACK";
export const SCN_TYPES = [SCN_POOL, SCN_RACK];
